import type { DeviceContextType } from '@archipro-website/types';
import type { PaginatedProfessionalsProp } from '../component/network-tab/PaginatedNetwork';
import { PaginatedNetwork } from '../component/network-tab/PaginatedNetwork';
import { useLoaderData } from '@remix-run/react';
import { useIsDisabledInPreview } from '@modules/root/hook/use-is-disabled-in-preview';

interface Loader extends PaginatedProfessionalsProp {
    deviceType: DeviceContextType;
}

const NetworkPage = () => {
    const data = useLoaderData() as Loader;
    const disableTileLink = useIsDisabledInPreview('featured_tile_links');
    const disableSaveToDesignBoard =
        useIsDisabledInPreview('save_design_board');
    const disableSort = useIsDisabledInPreview('directory_sort');

    return (
        <PaginatedNetwork
            {...data}
            disableTileLink={disableTileLink}
            disableSaveToDesignBoard={disableSaveToDesignBoard}
            disableSort={disableSort}
        />
    );
};

export default NetworkPage;
